import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'transmute/debounce';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import HR from 'UIComponents/elements/HR';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import CloseButton from './CloseButton';
import DialogCloseButton from './DialogCloseButton';
import FiltersBar from '../common/FiltersBar';
import NoTicketsFoundMessage from '../common/NoTicketsFoundMessage';
import TicketFiltersPanel from '../filter-panel/TicketFiltersPanel';
import TicketPanelItem from './TicketPanelItem';
import TicketSearchInput from '../common/TicketSearchInput';
import TicketsLoadingSpinner from '../common/TicketsLoadingSpinner';
import ViewInZorseButton from './ViewInZorseButton';
import { searchMoreTickets } from '../../actions/TicketActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FETCH_DELAY_MILLIS = 100;
function TicketSearchPanel(props) {
  const dispatch = useDispatch();
  const filters = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters);
  const searchTerms = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.searchTerms);
  const tickets = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.tickets);
  const [isFilterPanelOpen, setFilterPanelOpen] = useState(false);
  function handleFetchNext() {
    if (tickets.isLoading || !tickets.data.hasMore) {
      return;
    }
    dispatch(searchMoreTickets(searchTerms, tickets.data.lastId, filters));
  }
  const handleScrollDelayed = debounce(FETCH_DELAY_MILLIS, ({
    clientHeight,
    scrollHeight,
    scrollTop
  }) => {
    const isBottom = scrollHeight - scrollTop === clientHeight;
    if (isBottom) {
      handleFetchNext();
    }
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isFilterPanelOpen ? /*#__PURE__*/_jsx(TicketFiltersPanel, {
      "data-test-id": "search-panel-filters-panel",
      onClose: () => setFilterPanelOpen(false)
    }) : null, /*#__PURE__*/_jsxs(UIPanel, {
      "data-test-id": "search-panel-internal",
      width: 320
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      onScroll: ({
        target
      }) => handleScrollDelayed(target),
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "search-panel-dialog-close-button",
        onClick: props.onClose
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ className: string; "data-test-id": string;... Remove this comment to see the full error message
        ,
        className: "m-right-3"
      }), /*#__PURE__*/_jsx(UIPanelHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "search-panel-title",
            message: "app.title"
          })
        })
      }), /*#__PURE__*/_jsxs(UIPanelBody, {
        className: "p-all-3",
        children: [/*#__PURE__*/_jsx("div", {
          className: "m-bottom-4",
          children: /*#__PURE__*/_jsx(TicketSearchInput, {
            "data-test-id": "search-panel-search-input"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "m-bottom-2",
          children: /*#__PURE__*/_jsx(FiltersBar, {
            "data-test-id": "search-panel-filters-bar",
            onFiltersClick: () => setFilterPanelOpen(true)
          })
        }), /*#__PURE__*/_jsx(HR, {
          distance: "small"
        }), /*#__PURE__*/_jsx(UIList, {
          children: tickets.data.tickets.map((ticket, i) => /*#__PURE__*/_jsxs("span", {
            children: [i > 0 ? /*#__PURE__*/_jsx(HR, {
              distance: "small"
            }) : null, /*#__PURE__*/_jsx(TicketPanelItem, {
              ticket: ticket
            })]
          }, i))
        }), tickets.hasNoResults ? /*#__PURE__*/_jsx(NoTicketsFoundMessage, {
          "data-test-id": "search-panel-no-tickets-found-message",
          isLong: true
        }) : null, tickets.isLoading ? /*#__PURE__*/_jsx(TicketsLoadingSpinner, {
          "data-test-id": "search-panel-loading-spinner"
        }) : null]
      }), /*#__PURE__*/_jsx(UIPanelFooter, {
        style: {
          padding: '22px'
        },
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          justify: "start",
          direction: "row",
          wrap: "wrap",
          children: [/*#__PURE__*/_jsx(CloseButton, {
            "data-test-id": "search-panel-close-button",
            onClick: props.onClose
          }), /*#__PURE__*/_jsx(UIFlex, {
            align: "center",
            justify: "end",
            direction: "row",
            wrap: "wrap",
            children: /*#__PURE__*/_jsx(ViewInZorseButton, {
              "data-test-id": "search-panel-view-in-zorse-button"
              // @ts-expect-error ts-migrate(2322) FIXME: Type '{ "data-test-id": string; searchTerms: any; ... Remove this comment to see the full error message
              ,
              searchTerms: searchTerms
            })
          })]
        })
      })]
    })]
  });
}
TicketSearchPanel.propTypes = {
  onClose: PropTypes.func.isRequired
};
export default TicketSearchPanel;